<template>
  <div v-if="!item.hidden">
    
    <template v-if="typeof(item.children)=='undefined' || item.children.length==0 || item.meta.isDashboard">
      <app-link v-if="item.meta" :to="item.meta.fullPath">
        <el-menu-item :index="item.meta.fullPath" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.meta&&item.meta.icon" :iconClass="item.meta.icon||(item.meta&&item.meta.icon)"></svg-icon>
          {{item.meta.title=='工作台'&&!opened?"":item.meta.title}}
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="item.meta.fullPath" popper-append-to-body>
      <template slot="title">
        <m-item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child"
        :base-path="child.path" class="nest-menu" />
    </el-submenu>

    <!-- <el-submenu :index="item.path" >
      <template slot="title">
        <i class="el-icon-location"></i>
       {{item.meta.title}}
      </template>
      <el-submenu v-for="(child,index) in item.children" :key="index" :index="item.path+'-'+index">
        <span slot="title">  {{child.meta.title}}</span>
         <app-link v-for="(e,i) in child.children" :key="i"  :to="e.meta.fullPath">
        <el-menu-item :index="item.path+'-'+index+'-'+i">  {{e.meta.title}}</el-menu-item>
         </app-link>
            
      </el-submenu>
    </el-submenu> -->
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import mItem from "./item";
import appLink from "./link";

export default {
  name: "SidebarItem",
  components: { appLink, mItem },
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  computed: {
    opened() {
      return this.$store.state.app.sidebar.opened;
    },
  },
  mounted(){
    
  },
  methods: {},
};
</script>
